export const appDownloadUrlIos = "https://itunes.apple.com/cn/app/id1537949620";
export const appDownloadUrlAndroid = "https://static.gtech.asia/static/speedbiz/speedbiz.apk";
export const systemCodeAppMap = {
  APPC0010: "speedbiz",
  APPC0020: "wintogether",
  APPC0030: "b2bpoints",
  APPC0040: "b2bcash"
};



// WEBPACK FOOTER //
// ./src/utils/constant.js